// Shared chart/canvas color helpers and palette for the IRP workbook analysis
// tabs (Barrier Effectiveness, Report Clustering). Pure functions + constants —
// no React, no Chart.js dependency.

/** Colors for chart lines — excludes green/red to avoid confusion with success/failure */
export const CHART_COLORS = [
    'rgba(33, 150, 243, 1)',    // Blue
    'rgba(255, 152, 0, 1)',     // Orange
    'rgba(156, 39, 176, 1)',    // Purple
    'rgba(0, 188, 212, 1)',     // Cyan
    'rgba(255, 193, 7, 1)',     // Amber
    'rgba(96, 125, 139, 1)',    // Blue Grey
    'rgba(233, 30, 99, 1)',     // Pink
    'rgba(139, 195, 74, 1)',    // Light Green
];

/** Default success/failure colors (matching highlightDnaPath in canvas-environment.ts). */
export const COLOR_SUCCESS = '#008400';
export const COLOR_FAILURE = '#FF4365';
/** Colorblind-safe pair (Okabe-Ito blue / vermilion) — distinguishable under red-green CVD. */
export const COLOR_SUCCESS_CVD = '#0072B2';
export const COLOR_FAILURE_CVD = '#D55E00';
export const COLOR_NO_MAPPING = '#f0f0f0';

/** Convert a `#rrggbb` color to its `{r, g, b}` channels. */
export const hexToRgb = (hex: string): {r: number; g: number; b: number} => {
    const n = parseInt(hex.slice(1), 16);
    return {r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255};
};

/** Convert a `#rrggbb` color to an `rgba(r, g, b, alpha)` string. */
export const hexToRgba = (hex: string, alpha: number): string => {
    const {r, g, b} = hexToRgb(hex);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

/** Blend success → failure by failure proportion (0 = all success, 1 = all failure). */
export const blendSuccessFailure = (
    failRatio: number,
    success: {r: number; g: number; b: number},
    failure: {r: number; g: number; b: number},
): string => {
    const r = Math.round(success.r + (failure.r - success.r) * failRatio);
    const g = Math.round(success.g + (failure.g - success.g) * failRatio);
    const b = Math.round(success.b + (failure.b - success.b) * failRatio);
    return `rgb(${r},${g},${b})`;
};
